import { c as _c } from "react/compiler-runtime";
import { ComponentProps, HTMLAttributes, MouseEvent, PropsWithChildren } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { cn } from '@/lib/utils';
type PopoverMenuItemProps = HTMLAttributes<HTMLDivElement> & {
  isActive?: boolean;
  isLoading?: boolean;
  disabled?: boolean;
};
function PopoverMenuItem(t0) {
  const $ = _c(22);
  let children;
  let className;
  let onClick;
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      isActive: t1,
      isLoading: t2,
      disabled: t3,
      onClick,
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = onClick;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    children = $[1];
    className = $[2];
    onClick = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
  }
  const isActive = t1 === undefined ? false : t1;
  const isLoading = t2 === undefined ? false : t2;
  const disabled = t3 === undefined ? false : t3;
  let t4;
  if ($[8] !== disabled || $[9] !== isLoading || $[10] !== onClick) {
    t4 = e => {
      if (disabled || isLoading) {
        return;
      }
      e.stopPropagation();
      onClick?.(e);
    };
    $[8] = disabled;
    $[9] = isLoading;
    $[10] = onClick;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleClick = t4;
  let t5;
  if ($[12] !== className || $[13] !== disabled || $[14] !== isActive || $[15] !== isLoading) {
    t5 = cn("body-1 hover:bg-vive-primary-60 flex min-w-[144px] cursor-pointer items-center gap-[8px] rounded-sm p-[6px] transition-all hover:text-white lg:p-[8px]", {
      "text-vive-brand-50": isActive,
      "cursor-wait": isLoading,
      "cursor-not-allowed": disabled
    }, className);
    $[12] = className;
    $[13] = disabled;
    $[14] = isActive;
    $[15] = isLoading;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== children || $[18] !== handleClick || $[19] !== props || $[20] !== t5) {
    t6 = <div className={t5} onClick={handleClick} {...props}>{children}</div>;
    $[17] = children;
    $[18] = handleClick;
    $[19] = props;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
}
type PopoverMenuItemsGroupProps = PropsWithChildren<{
  title?: string;
}>;
function PopoverMenuItemsGroup(t0) {
  const $ = _c(5);
  const {
    title,
    children
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = title && <div className="caption">{title}</div>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div className="flex flex-col gap-[8px]">{t1}{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function PopoverMenuSeparator() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Separator className="bg-vive-primary-60 h-0.5" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
type PopoverMenuProps = PropsWithChildren<ComponentProps<typeof Card>>;
export default function PopoverMenu(t0) {
  const $ = _c(12);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("bg-vive-primary-70 text-vive-primary-20 w-fit border-0 p-2", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children) {
    t2 = <CardContent className="flex flex-col gap-[8px] p-0">{children}</CardContent>;
    $[6] = children;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== t1 || $[10] !== t2) {
    t3 = <Card className={t1} {...props}>{t2}</Card>;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
PopoverMenu.Separator = PopoverMenuSeparator;
PopoverMenu.Group = PopoverMenuItemsGroup;
PopoverMenu.Item = PopoverMenuItem;